import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";

interface ProposeTimeProps{
    data:any,
    setClose:()=>void,
    onSubmit:(data:any)=>void,
    t:any
}

const ProposeTime = ({data, setClose, onSubmit, t}:ProposeTimeProps) => {
    const show=!!data;

  const [selectedTime, setSelectedTime] = useState("");
  const [note, setNote] = useState("");

  const handleClose = () => setClose();

  const convertRangeToISO = (range:any) => {
    if (!range) return null;
    const [startStr, endStr] = range.split("-");

    const parseTime = (timeStr:string) => {
      const [time, period] = timeStr.split(" ");
      let [hour, minute] = time.split(":").map(Number);
      if (period === "PM" && hour !== 12) hour += 12;
      if (period === "AM" && hour === 12) hour = 0;

      const date = new Date(data?.teesheetObj?.dateTimeISO);
      date.setUTCHours(hour, minute, 0, 0);
      return date.toISOString();
    };

    return {
      startISO: parseTime(startStr),
      endISO: parseTime(endStr),
    };
  };

  const generateTimes = () => {
    const ranges = [];
    let start = 7 * 60;  // 7:00 AM in minutes
    let end = 18 * 60;   // 6:00 PM in minutes

    for (let mins = start; mins < end; mins += 30) {
      let startHour = Math.floor(mins / 60);
      let startMin = mins % 60;
      let endMins = mins + 30;
      let endHour = Math.floor(endMins / 60);
      let endMin = endMins % 60;

      const formatTime = (h:any, m:any) => {
        let suffix = h >= 12 ? "PM" : "AM";
        let displayHour = h % 12 === 0 ? 12 : h % 12;
        return `${displayHour}:${m.toString().padStart(2, "0")} ${suffix}`;
      };

      ranges.push(`${formatTime(startHour, startMin)}-${formatTime(endHour, endMin)}`);
    }
    return ranges;
  };

  const handleSubmit = () => {
    onSubmit({
        startTime: selectedTime,
        dateTimeISO: convertRangeToISO(selectedTime)?.startISO ?? "",
        notes:note ?? "",
        status:"userConfirmationPending"
    })
    handleClose();
    setNote("")
  };

  return (
    <>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("NetRatePage.proposeTeeTime")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>{t("NetRatePage.existingTeeTime")}</Form.Label>
              <Form.Select
                value={data?.startTime}
                disabled={true}
                
              >
                <option value={data?.startTIme}>{data?.startTime}</option>
                {/* {generateTimes().map((time, i) => (
                  <option key={i} value={time}>
                    {time}
                  </option>
                ))} */}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{t("NetRatePage.selectNewTime")}</Form.Label>
              <Form.Select
                value={selectedTime}
                onChange={(e) => setSelectedTime(e.target.value)}
              >
                <option value="">{t("NetRatePage.selectATime")}</option>
                {generateTimes().map((time, i) => (
                  <option key={i} value={time}>
                    {time}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* <Form.Group className="mb-3">
              <Form.Label>Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Add a note..."
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </Form.Group> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("NetRatePage.form.cancel")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!selectedTime}>
            {t("NetRatePage.form.submit")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProposeTime;
